<template>
  <ok-text-input v-bind="$props">
    <v-select
      :value="value"
      :options="options"
      :disabled="readonly"
      :multiple="multiple"
      :reduce="template => template.id"
      :loading="loading"
      dir="rtl"
      :placeholder="placeholder || $t('general.please-select')"
      :clearable="multiple || clearable"
      :class="{'select-size-lg': size === 'lg', 'select-size-sm': size === 'sm', 'is-invalid': state === false}"
      autocomplete="off"
      @input="$emit('input', $event)"
    >
      <template
        slot="option"
        slot-scope="option"
      >
        <div
          class="d-center"
        >
          {{ option[labelKey] }}
        </div>
      </template>
      <template
        slot="selected-option"
        slot-scope="option"
      >
        {{ option[labelKey] }}
      </template>
    </v-select>
  </ok-text-input>
</template>

<script>
import vSelect from 'vue-select'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import okTextInputProps from '@/@bya3/components/inputs/utils/ok-text-input-props'

export default {
  name: 'GeneralTemplatesSelect',
  components: {
    OkTextInput,
    vSelect,
  },
  props: {
    ...okTextInputProps,
    value: {
      type: [String, Number],
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    state: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    labelKey: {
      type: String,
      default: 'name',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
    }
  },
}
</script>
